<template>
  <div class="alert-list">
    <div v-if="alertList.length > 0">
      <div
        v-for="(alert, index) in alertList"
        :key="index">
        <AlertItem :id="index" :alert=alert @close="closeAlert(alert.idt_aff_notification,index)"/>
      </div>
    </div>
  </div>
</template>

<script>
import AlertItem from '@/components/AlertItem';
import AlertApi from '@/services/alerts';
import { mapGetters } from 'vuex';

export default {
  name: 'AlertList',
  components: {
    AlertItem,
  },
  computed: {
    ...mapGetters([
      'isAnyUrlApproved',
    ]),
  },
  data() {
    return {
      alertList: [],
    };
  },
  methods: {
    async getAlerts() {
      const alerts = await AlertApi.getAlerts();
      if (alerts) {
        this.alertList = await alerts.map(alert => ({
          ...alert,
          type: alert.type.toLowerCase(),
        }));
      }
      if (!this.isAnyUrlApproved) {
        this.alertList = [{
          body: '<p>Verifique o status das URLs cadastradas e faça as alterações necessárias para começar a divulgar. <a target="_blank" href="https://afiliados.uol.com.br/novo/cadastro.html">Verificar sites</a></p>',
          idtAffNotification: 999,
          mobileShowBody: true,
          showClose: false,
          title: 'Verifique seus sites cadastrados',
          type: 'warning',
        }];
      }
    },

    async closeAlert(alertId, index) {
      await AlertApi.closeAlert(alertId);
      this.alertList.splice(index, 1);
      await this.getAlerts();
    },
  },
  async created() {
    await this.getAlerts();
  },
};
</script>

<style>
  .alert-list {
    padding-top: 0.8rem
  }
</style>
